module.exports = "https://health.dajiuxing.com.cn/img/assets/img/qykbj.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2Fqykbj.png
// module id = mXof
// module chunks = 93